import { render, staticRenderFns } from "./virtual-update.vue?vue&type=template&id=96ee82fc&scoped=true&"
import script from "./virtual-update.vue?vue&type=script&lang=js&"
export * from "./virtual-update.vue?vue&type=script&lang=js&"
import style0 from "./virtual-update.vue?vue&type=style&index=0&lang=less&"
import style1 from "./virtual-update.vue?vue&type=style&index=1&id=96ee82fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ee82fc",
  null
  
)

export default component.exports